import { useParams } from "react-router";
import NewSubmittalDetailsPage from "./new-submittal-details/submittal-details";

function SubmittalDetailspage() {
  const { submittalId } = useParams() as { submittalId: string };

  // The page itself holds the editable draft of the submittal, so remounting on
  // the id is what stops the prev/next navigator carrying one record's data
  // into the next.
  return <NewSubmittalDetailsPage key={submittalId} />;
}

export default SubmittalDetailspage;
